export default __webpack_public_path__ + "static/media/QuestionBox.abcdf24e.svg";